import { Holding, MacroState, MarketSignal } from '../types';

export const MOCK_HOLDINGS: Holding[] = [
  { symbol: 'NVDA', shares: 50, avgCost: 120.5, weight: 0.25, targetWeight: 0.20, market: 'US' },
  { symbol: 'TSLA', shares: 100, avgCost: 180.2, weight: 0.15, targetWeight: 0.10, market: 'US' },
  { symbol: 'AAPL', shares: 80, avgCost: 175.0, weight: 0.20, targetWeight: 0.25, market: 'US' },
  { symbol: 'MSFT', shares: 40, avgCost: 410.5, weight: 0.18, targetWeight: 0.20, market: 'US' },
  { symbol: '005930.KS', shares: 200, avgCost: 72000, weight: 0.12, targetWeight: 0.15, market: 'KR' },
  { symbol: '000660.KS', shares: 50, avgCost: 160000, weight: 0.10, targetWeight: 0.10, market: 'KR' },
];

export const MOCK_MACRO: MacroState = {
  asOfDate: new Date().toISOString().split('T')[0],
  regimes: {
    liquidity: 'Neutral',
    credit: 'Flat',
    policy: 'Blackout',
  },
  riskMetrics: {
    riskScore: 58,
    macroWeight: 0.85,
    portfolioRiskBudgetPct: 15,
    trimThresholdPct: 5,
    updatedAt: new Date().toISOString(),
  },
  aiSummary: '현재 시장은 연준의 블랙아웃 기간에 진입하며 유동성 공급이 제한적인 중립 상태입니다. 신용 확장은 정체되어 있으나 고용 지표가 견조하여 급격한 경기 침체 우려는 낮습니다. 다만 단기적인 변동성 확대에 대비한 리스크 관리가 필요한 시점입니다.',
  fedFunds: { value: 5.33, date: '2024-02-01' },
  inflation: { value: 3.15, date: '2024-01-01' },
  unemployment: { value: 3.9, date: '2024-02-01' },
  government: {
    treasury10Y: { value: 4.25, date: '2024-03-22', change: 0.05 },
    treasury5Y: { value: 4.10, date: '2024-03-22', change: 0.03 },
    treasury2Y: { value: 4.62, date: '2024-03-22', change: 0.02 },
    tgaBalance: { value: 750.4, date: '2024-03-22', change: 1.5 },
    fedBalanceSheet: { value: 7450.2, date: '2024-03-22', change: -0.5 },
    reverseRepo: { value: 450.1, date: '2024-03-22', change: -2.1 },
    m2MoneySupply: { value: 20850.5, date: '2024-01-01', change: -0.2 }
  },
  futures: {
    sp500: { value: 5200.25, date: '2024-03-22', change: 0.15 },
    nasdaq: { value: 18200.5, date: '2024-03-22', change: 0.25 },
    dow: { value: 39500, date: '2024-03-22', change: 0.1 },
    russell: { value: 2100.5, date: '2024-03-22', change: -0.05 },
    treasury10y: { value: 110.25, date: '2024-03-22', change: 0.02 },
    vix: { value: 14.5, date: '2024-03-22', change: -1.2 }
  }
};

export const MOCK_SIGNALS: MarketSignal[] = [
  { symbol: 'NVDA', price: 135.2, pctChange: 2.5, shortRatio: 0.15, daysToCover: 1.2, putCallRatio: 0.65, ivRank: 45, gammaFlip: 130, totalScore: 32, alertLevel: 'WATCH', portfolioAction: 'HOLD', proposedTradeShares: 0 } as any,
  { symbol: 'TSLA', price: 172.5, pctChange: -4.2, shortRatio: 0.55, daysToCover: 4.5, putCallRatio: 1.35, ivRank: 82, gammaFlip: 185, totalScore: 88, alertLevel: 'CRITICAL', portfolioAction: 'EXIT', proposedTradeShares: -100 } as any,
  { symbol: 'AAPL', price: 182.1, pctChange: 0.8, shortRatio: 0.12, daysToCover: 1.1, putCallRatio: 0.72, ivRank: 32, gammaFlip: 175, totalScore: 15, alertLevel: 'NORMAL', portfolioAction: 'HOLD', proposedTradeShares: 0 } as any,
];
